/**
 * Painel de gestão (Prompt 11): só indicadores que ajudam a administrar a
 * equipe. Valores em reais, segundos e contagens; a tela formata.
 */
import { z } from "zod";

export const filtroPainelSchema = z.object({
  de: z.string().datetime({ offset: true }),
  ate: z.string().datetime({ offset: true }),
  empresaId: z.string().uuid().optional(),
  usuarioId: z.string().uuid().optional(),
  etiquetaId: z.string().uuid().optional(),
});
export type FiltroPainel = z.infer<typeof filtroPainelSchema>;

export interface PainelAgora {
  emAndamento: number;
  aguardandoResposta: number;
  semResponsavel: number;
  noModoPonte: number;
  paraRetomar: number;
  /** Desde quando a cliente que espera há mais tempo espera. */
  esperaMaisAntiga: string | null;
  acimaDoPrazo: number;
}

export interface LinhaVendedora {
  usuarioId: string;
  nome: string;
  atendimentos: number;
  respostas: number;
  primeiraRespostaMediaSeg: number | null;
  respostaMediaSeg: number | null;
  dentroDoPrazoPct: number | null;
  pedidos: number;
  faturamento: number;
  vendasSite: number;
  faturamentoSite: number;
  conversaoPct: number | null;
  produtosEnviados: number;
}

export interface PontoSerie {
  dia: string;
  conversas: number;
  pedidos: number;
  faturamento: number;
}

export interface Painel {
  agora: PainelAgora;
  periodo: {
    conversasNovas: number;
    conversasConcluidas: number;
    tempoMedioAtendimentoSeg: number | null;
    primeiraRespostaMediaSeg: number | null;
    respostaMediaSeg: number | null;
    /** % das respostas dentro do prazo (antes de "estourado"). */
    dentroDoPrazoPct: number | null;
    respostasComIa: number;
    pedidos: number;
    pedidosCancelados: number;
    faturamentoPedidos: number;
    faturamentoConfirmado: number;
    vendasSite: number;
    faturamentoSite: number;
    ticketMedio: number | null;
    conversaoPct: number | null;
    clientesNovos: number;
    clientesRecorrentes: number;
    conversasPerdidas: number;
    produtosEnviados: number;
    cliquesEmLinks: number;
  };
  vendedoras: LinhaVendedora[];
  serie: PontoSerie[];
  prazoMin: number;
}
